import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-54554740"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vod-statistics-warp"
};
const _hoisted_2 = {
  class: "info-warp"
};
const _hoisted_3 = {
  class: "tabs-warp"
};
const _hoisted_4 = {
  class: "left-warp"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "right-warp"
};
const _hoisted_7 = {
  class: "icon-warp"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "data-warp"
};
const _hoisted_11 = {
  class: "count-statistics-warp"
};
import TableData from './components/TableData.vue';
import NumStatistics from './components/NumStatistics.vue';
import LineChart from './components/LineChart.vue';
import { useI18n } from 'vue-i18n';
import { nextTick, onMounted, provide } from 'vue';
import { useBrandsByUser, useVodLanguages } from '@/utils/cacheData';
import dayjs from 'dayjs';
import { debounce, getItemByProp } from '@/utils/tools';
import { getLanguageTotalApi, getOnlineOfflineCountApi, getProgramDataApi, getVideoCountApi, getVodMainAgentApi, getVodSubAgentApi } from '@/api/statistics';
import { useCommon } from '@/store/useCommon';
import { htmlToExcel } from '@/utils/htmlToExcel';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const countStatisticsRef = ref(null); // 左侧tabs item列表

    const leftTabsList = ref([{
      label: '电影',
      value: 0
    }, {
      label: '电视剧 (部)',
      value: 1
    }, {
      label: '电视剧剧集',
      value: 2
    }]); // 右侧icon 图标列表

    const iconsList = ref([{
      name: '表格',
      value: 'table',
      defaultUrl: require('./images/ic_list_unsel.png'),
      selectUrl: require('./images/ic_list_sel.png')
    }, {
      name: '折线图',
      value: 'line',
      defaultUrl: require('./images/ic_chart_unsel.png'),
      selectUrl: require('./images/ic_chart_sel.png')
    }, {
      name: '下载',
      value: 'download',
      defaultUrl: require('./images/ic_download_unsel.png'),
      selectUrl: require('./images/ic_download_sel.png')
    }]); // 右侧时间tabs item列表

    const timeTabsList = ref([{
      label: '日',
      value: 'day'
    }, {
      label: '月',
      value: 'month'
    }, {
      label: '年',
      value: 'year'
    }]); // 左侧tabs item默认选中

    const currentLeftTabsSelect = ref(0); // 右侧icon item默认选中

    const currentIconSelect = ref('table'); // 右侧时间tabs item默认选中

    const currentRightTabsSelect = ref('day');
    const shortcuts = [{
      text: t('最近一周'),
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      }
    }, {
      text: t('最近一个月'),
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      }
    }, {
      text: t('最近一年'),
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
        return [start, end];
      }
    }];
    const chooseDay = ref(null);
    const searchConfig = reactive({
      // size: { sm: 24, md: 12, lg: 8, xl: 6, xs: {} },
      size: {
        sm: 24,
        md: 12,
        lg: 12,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: [],
        change: async val => {
          sessionStorage.setItem('currentCid', val);
          let item = getItemByProp(searchConfig.formList, 'subAgentId');
          item.list = [{
            id: '',
            name: t('全部')
          }];
          searchConfig.formData.mainAgentId = '';
          searchConfig.formData.subAgentId = '';
          await getVodMainAgent();
          getVideoCount();
          getAllDataApi();
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_FR_BS') > -1;
        },
        disabled: useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')
      }, {
        label: '主品牌',
        prop: 'mainAgentId',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          id: '',
          name: t('全部')
        }],
        change: val => {
          searchConfig.formData.subAgentId = '';

          if (!val) {
            let item = getItemByProp(searchConfig.formList, 'subAgentId');
            item.list = [{
              id: '',
              name: t('全部')
            }];
          } else {
            getVodSubAgent(val);
          }

          getAllDataApi();
        },
        controller: () => {
          return true;
        }
      }, {
        label: '子品牌',
        prop: 'subAgentId',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          id: '',
          name: t('全部')
        }],
        change: val => {
          getAllDataApi();
        },
        controller: () => {
          return true;
        }
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择语言',
        valueKey: 'labelValue',
        // multiple: true, collapseTags: true, collapseTagsTooltip: true,
        change: val => {
          // if (!val.includes(-1) && val.length == languageOptions.value.length) {
          //     searchConfig.formData.language.unshift(-1);
          // } else if (val.includes(-1) && (val.length - 1) < searchConfig.formData.language.length) {
          //     searchConfig.formData.language = searchConfig.formData.language.filter((item) => {
          //         return item !== -1;
          //     })
          // }
          getAllDataApi();
        },
        optionItemNativeClick: (val, item, data) => {// console.log(val, item, data);
          // if (val == -1) {
          //     selectLanguageAll();
          // }
        },
        list: [],
        // removeTag: (val) => { removeLanguageTag(val); },
        class: 'language-select'
      }, {
        label: '时间维度',
        prop: 'timeDimension',
        widgetType: 'Select',
        filterable: true,
        change: val => {},
        translation: true,
        list: [{
          label: '日_s',
          value: 'day'
        }, {
          label: '周_s',
          value: 'week'
        }, {
          label: '月_s',
          value: 'month'
        }]
      }, {
        label: '时间范围',
        prop: 'time',
        widgetType: 'date',
        placeholder: '请选择时间',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        // shortcuts: shortcuts,
        clearable: false,
        editable: false,
        unlinkPanels: true,
        controller: (value, data, config) => {
          return true;
        },
        firstDayOfWeek: 1,
        // calendarChange: (date) => {
        //     if (searchConfig.formData.timeDimension != 'week') return;
        //     chooseDay.value = date[0];
        // },
        focus: () => {// nextTick(() => {
          //     chooseDay.value = null;
          // });
        },
        disabledDate: time => {
          // if (chooseDay.value && searchConfig.formData.timeDimension == 'week') {
          //     // 如果选择了一个日期
          //     const sevenDayTime = 7 * 24 * 3600 * 1000; // 7天的时间戳
          //     const minTime = chooseDay.value - sevenDayTime;  // 当前日期 - 7天之前
          //     const maxTime = chooseDay.value - 0 + sevenDayTime; // 当前日期 7天之后(必须-0，不然不会变成数字时间戳格式)
          //     return ((time.getTime() !== chooseDay.value || time.getTime() > Date.now()) && (time.getTime() !== minTime || time.getTime() > Date.now()) && (time.getTime() !== maxTime || time.getTime() > Date.now()));
          // } else {
          //     return time.getTime() > Date.now();  // 如果没有选择日期，就要限制不能选择还没到的日期
          // }
          return time.getTime() > Date.now();
        },
        change: val => {
          if (searchConfig.formData.timeDimension == 'week') {
            nextTick(() => {
              const date = new Date(val);
              const y = date.getFullYear();
              const m = date.getMonth();
              const d = date.getDate();
              const week = date.getDay();
              const start = new Date(y, m, d - week);
              const end = new Date(y, m, d - week + 6);
              baseForm.value.startTime = getCurrentTime(start, 0);
              baseForm.value.endTime = getCurrentTime(end, 0); // console.log('baseForm', baseForm);

              let datePickConfig = getItemByProp(searchConfig.formList, 'time');
              datePickConfig.format = `${baseForm.value.startTime + ' ' + ' - ' + ' ' + baseForm.value.endTime}`;
              getAllDataApi();
            });
          } else {
            getAllDataApi();
          }
        }
      }],
      formData: {
        cid: null,
        mainAgentId: '',
        subAgentId: '',
        language: [],
        timeDimension: 'day',
        time: []
      },
      search: () => {
        // console.log(searchConfig.formData);
        getAllDataApi();
      },
      reset: async () => {
        searchConfig.formData.cid = Number(sessionStorage.getItem('currentCid'));
        searchConfig.formData.timeDimension = 'day'; // searchConfig.formData.time = dayjs().endOf('day').format('YYYY-MM-DD') as any;

        searchConfig.formData.time = [dayjs().startOf('day').format('YYYY-MM-DD'), dayjs().endOf('day').format('YYYY-MM-DD')]; // selectLanguageAll();
        // let item = getItemByProp(searchConfig.formList, 'mainAgentId');
        // if (item.list.length) {
        //     searchConfig.formData.mainAgentId = item.list[0].id;
        //     await getVodSubAgent(item.list[0].id);
        // }
      }
    });
    provide('timeDimension', computed(() => searchConfig.formData.timeDimension));
    provide('time', computed(() => searchConfig.formData.time));
    const baseForm = ref({
      startTime: '',
      endTime: ''
    }); // 时间戳转为yy-mm-dd

    const getCurrentTime = (data, num) => {
      let date = new Date(data);
      const Y = date.getFullYear();
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const D = date.getDate() + num < 10 ? '0' + (date.getDate() + num) : date.getDate() + num;
      date = Y + '-' + M + '-' + D;
      return date;
    }; // 左侧tabs item点击事件


    const leftTabsItemClick = debounce(async item => {
      // console.log(item);
      if (currentLeftTabsSelect.value == item.value) return;
      currentLeftTabsSelect.value = item.value;
      getAllDataApi();
    }, 200); // 右侧icons item点击事件

    const rightIconItemClick = debounce(async item => {
      // console.log(item);
      if (currentIconSelect.value == item.value) return;

      if (item.value == 'download') {
        if (tableData.value.length) {
          viewLoading.value = true;
          await htmlToExcel('#statistics-table-warp');
          setTimeout(() => {
            viewLoading.value = false;
          }, 300);
        }

        return;
      }

      currentIconSelect.value = item.value;
      getAllDataApi();
    }, 200); // 右侧时间 tabs item点击事件

    const rightTimeItemClick = item => {
      // console.log(item);
      currentRightTabsSelect.value = item.value;
    }; // 获取主品牌下拉


    const getVodMainAgent = async () => {
      try {
        const res = await getVodMainAgentApi({
          cid: searchConfig.formData.cid
        }); // console.log('getVodMainAgentApi', res);

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'mainAgentId'); // item.list = res.data;
          // if (res.data && res.data.length) {
          //     searchConfig.formData.mainAgentId = res.data[0].id;
          //     getVodSubAgent(res.data[0].id);
          // }

          item.list = [{
            id: '',
            name: t('全部')
          }, ...res.data];
        }
      } catch (error) {
        viewLoading.value = false;
      }
    }; // 获取子品牌下拉


    const getVodSubAgent = async mainAgentId => {
      try {
        const res = await getVodSubAgentApi({
          mainAgentId
        });
        let item = getItemByProp(searchConfig.formList, 'subAgentId'); // console.log('getVodSubAgentApi', res);

        if (res.code == '0') {
          item.list = [...item.list, ...res.data];
        }
      } catch (error) {}
    };

    const viewLoading = ref(false); // 是否为VNO账号

    const isVnoUser = computed(() => useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')); // 获取品牌选项数据

    const getBrands = async () => {
      viewLoading.value = true;

      try {
        if (useCommon().userData.permissionKey.indexOf('DC_FR_BS') > -1) {
          const brands = await useBrandsByUser();
          let searchItem = getItemByProp(searchConfig.formList, 'cid');
          if (searchItem) searchItem.list = brands;
          let cid = sessionStorage.getItem('currentCid');

          if (!cid) {
            sessionStorage.setItem('currentCid', isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid);
            cid = searchConfig.formData.cid = isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid;
          } else {
            searchConfig.formData.cid = Number(cid);
          }
        } else {
          let cid = useCommon().userData.cid[0] || 0;
          searchConfig.formData.cid = cid;
          sessionStorage.setItem('currentCid', cid);
        } // viewLoading.value = false;

      } catch (error) {
        viewLoading.value = false;
      }
    };

    const tableData = ref([]);

    const getData = async () => {
      try {
        let params = {
          // time: searchConfig.formData.timeDimension == 'week' ? [baseForm.value.startTime, baseForm.value.endTime] : searchConfig.formData.time,
          cid: searchConfig.formData.cid,
          time: searchConfig.formData.time,
          mainAgentId: searchConfig.formData.mainAgentId,
          subAgentId: searchConfig.formData.subAgentId,
          language: searchConfig.formData.language,
          programType: currentLeftTabsSelect.value,
          type: searchConfig.formData.timeDimension == 'day' ? 1 : searchConfig.formData.timeDimension == 'week' ? 2 : 3
        };
        const res = await getProgramDataApi(params); // console.log('getProgramDataApi', res);

        if (res.code == '0') {
          tableData.value = res.data;
        }
      } catch (error) {}
    };

    const languageTotalList = ref([]);

    const getLanguageTotal = async () => {
      try {
        let params = {
          // time: searchConfig.formData.timeDimension == 'week' ? [baseForm.value.startTime, baseForm.value.endTime] : searchConfig.formData.time,
          cid: searchConfig.formData.cid,
          time: searchConfig.formData.time,
          mainAgentId: searchConfig.formData.mainAgentId,
          subAgentId: searchConfig.formData.subAgentId,
          language: searchConfig.formData.language,
          programType: currentLeftTabsSelect.value,
          type: searchConfig.formData.timeDimension == 'day' ? 1 : searchConfig.formData.timeDimension == 'week' ? 2 : 3
        };
        const res = await getLanguageTotalApi(params); // console.log('getLanguageTotalApi', res);

        if (res.code == '0') {
          languageTotalList.value = res.data;
        }
      } catch (error) {}
    };

    provide('languageTotalList', languageTotalList);
    const numStatisticsObj = reactive({
      videoCountObj: {
        episodeCount: 0,
        movieCount: 0,
        seriesCount: 0,
        total: 0
      },
      onlineOfflineCountObj: {
        monthOfflineCount: 0,
        monthOnlineCount: 0,
        offlineCount: 0,
        onlineCount: 0,
        yesterdayOfflineCount: 0,
        yesterdayOnlineCount: 0
      }
    });

    const getOnlineOfflineCount = async () => {
      numStatisticsObj.onlineOfflineCountObj = {
        monthOfflineCount: 0,
        monthOnlineCount: 0,
        offlineCount: 0,
        onlineCount: 0,
        yesterdayOfflineCount: 0,
        yesterdayOnlineCount: 0
      };

      try {
        let params = {
          cid: searchConfig.formData.cid,
          time: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
          mainAgentId: searchConfig.formData.mainAgentId,
          subAgentId: searchConfig.formData.subAgentId,
          language: searchConfig.formData.language,
          programType: currentLeftTabsSelect.value
        };
        const res = await getOnlineOfflineCountApi(params); // console.log('getOnlineOfflineCountApi', res);

        if (res.code == '0') {
          numStatisticsObj.onlineOfflineCountObj = { ...res.data
          };
        }
      } catch (error) {}
    };

    const getVideoCount = async () => {
      numStatisticsObj.videoCountObj = {
        episodeCount: 0,
        movieCount: 0,
        seriesCount: 0,
        total: 0
      };

      try {
        const res = await getVideoCountApi({
          cid: searchConfig.formData.cid
        }); // console.log('getVideoCountApi', res);

        if (res.code == '0') {
          numStatisticsObj.videoCountObj = { ...res.data
          };
        }
      } catch (error) {
        viewLoading.value = false;
      }
    };

    provide('numStatisticsObj', numStatisticsObj); // 左侧表格/echart图例信息容器总高度

    const tableWarpClientHeight = ref(0); // 表格/echart图例最大高度

    const tableMaxHeight = ref(0);
    onMounted(async () => {
      getLangs();
      setDefaultTime();
      await getBrands();
      tableWarpClientHeight.value = countStatisticsRef.value.$el.clientHeight;
      let tabWarp = document.querySelector('.tabs-warp');
      tableMaxHeight.value = countStatisticsRef.value.$el.clientHeight - (tabWarp.clientHeight + 20 + 50 + 36); // console.log('tableMaxHeight', tableMaxHeight);
      // 监听页面尺寸变化 获取右侧统计数量容器高度赋值给左侧容器 达成两边相同高度

      window.addEventListener('resize', () => {
        // console.log(countStatisticsRef.value.$el.clientHeight);
        if (countStatisticsRef.value) {
          tableWarpClientHeight.value = countStatisticsRef.value.$el.clientHeight;
          let tabWarp = document.querySelector('.tabs-warp');
          tableMaxHeight.value = countStatisticsRef.value.$el.clientHeight - (tabWarp.clientHeight + 20 + 50 + 36); // console.log('tableMaxHeight', tableMaxHeight);
        }
      }, {
        passive: false
      });
      await getVodMainAgent();
      getVideoCount();
      getAllDataApi();
    });

    const getTitle = () => {
      let findItem = leftTabsList.value.find(f => f.value == currentLeftTabsSelect.value);
      return findItem && findItem.label == '电视剧 (部)' ? '电视剧' : findItem.label;
    }; // 全选或反全选语言


    const selectLanguageAll = () => {
      if (searchConfig.formData.language.length < languageOptions.value.length) {
        searchConfig.formData.language = [];
        languageOptions.value.map(item => {
          searchConfig.formData.language.push(item.value);
        });
        searchConfig.formData.language.unshift(-1);
      } else {
        searchConfig.formData.language = [];
      }
    }; // 移除语言选项tag回调函数


    const removeLanguageTag = val => {
      if (val == -1) {
        searchConfig.formData.language = [];
      }
    };

    const languageOptions = ref([]); // 获取所有语言

    const getLangs = async () => {
      const langs = await useVodLanguages();
      let item = getItemByProp(searchConfig.formList, 'language'); // item.list = [{ label: t('全部'), value: -1 }, ...langs];

      item.list = [{
        label: t('全部'),
        value: '',
        labelValue: ''
      }, ...langs];
      languageOptions.value = langs; // selectLanguageAll();
    }; // 设置时间范围默认时间


    const setDefaultTime = () => {
      let datePickConfig = getItemByProp(searchConfig.formList, 'time');

      if (searchConfig.formData.timeDimension == 'day') {
        datePickConfig.key = Date.now();
        datePickConfig.valueFormat = 'YYYY-MM-DD';
        datePickConfig.format = 'YYYY-MM-DD';
        datePickConfig.type = 'daterange'; // searchConfig.formData.time = dayjs().endOf('day').format('YYYY-MM-DD') as any;

        searchConfig.formData.time = [dayjs().startOf('day').format('YYYY-MM-DD'), dayjs().endOf('day').format('YYYY-MM-DD')];
      } else if (searchConfig.formData.timeDimension == 'week') {
        datePickConfig.key = Date.now();
        const date = new Date(dayjs().endOf('day').format('YYYY-MM-DD'));
        const y = date.getFullYear();
        const m = date.getMonth();
        const d = date.getDate();
        const week = date.getDay();
        const start = new Date(y, m, d - week);
        const end = new Date(y, m, d - week + 6); // baseForm.value.startTime = getCurrentTime(start, 0);
        // baseForm.value.endTime = getCurrentTime(end, 0);
        // console.log(baseForm.value);
        // datePickConfig.type = 'week';

        datePickConfig.valueFormat = 'YYYY-MM-DD';
        datePickConfig.format = 'YYYY-MM-DD';
        datePickConfig.type = 'daterange'; // datePickConfig.valueFormat = '';
        // datePickConfig.format = `${baseForm.value.startTime + ' ' + ' - ' + ' ' + baseForm.value.endTime}`;
        // searchConfig.formData.time = baseForm.value.startTime as any;

        searchConfig.formData.time = [getCurrentTime(start, 0), getCurrentTime(end, 0)];
      } else if (searchConfig.formData.timeDimension == 'month') {
        datePickConfig.key = Date.now();
        datePickConfig.valueFormat = 'YYYY-MM';
        datePickConfig.format = 'YYYY-MM'; // datePickConfig.type = 'month';

        datePickConfig.type = 'monthrange'; // searchConfig.formData.time = dayjs().endOf('day').format('YYYY-MM') as any;

        searchConfig.formData.time = [dayjs().startOf('month').format('YYYY-MM'), dayjs().endOf('month').format('YYYY-MM')];
      }
    };

    const getAllDataApi = async () => {
      // tableData.value = [];
      try {
        if (currentIconSelect.value == 'table') {
          viewLoading.value = true;
          let p1 = await getLanguageTotal();
          let p2 = getData();
          let p3 = getOnlineOfflineCount();
          Promise.all([p1, p2, p3]).then(res => {
            // console.log('getAllDataApiRes', res);
            viewLoading.value = false;
          }).catch(err => {
            // console.log('getAllDataApiError', err);
            viewLoading.value = false;
          });
        } else if (currentIconSelect.value == 'line') {
          await getLanguageTotal();
        }
      } catch (error) {
        viewLoading.value = false;
      }
    };

    const showViewLoading = type => {
      viewLoading.value = type;
    };

    watch(() => searchConfig.formData.timeDimension, val => {
      setDefaultTime();
      getAllDataApi();
    }, {
      // immediate: true,
      deep: true
    }); // watch(() => searchConfig.formData.time, (val) => {
    //     // console.log('time', val);
    //     chooseDay.value = null;
    // })

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "table-chart-warp cms-card-block",
        style: _normalizeStyle('height: ' + tableWarpClientHeight.value + 'px')
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftTabsList.value, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["tabs-item pointer", currentLeftTabsSelect.value == item.value ? 'is-left-tab-select' : '']),
          key: index,
          onClick: $event => _unref(leftTabsItemClick)(item)
        }, _toDisplayString(_unref(t)(item.label)), 11, _hoisted_5);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconsList.value, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: "pointer",
          key: index,
          onClick: $event => _unref(rightIconItemClick)(item)
        }, [_createElementVNode("img", {
          src: currentIconSelect.value == item.value ? item.selectUrl : item.defaultUrl,
          alt: ""
        }, null, 8, _hoisted_9)], 8, _hoisted_8);
      }), 128))])])]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createVNode(TableData, {
        "max-height": tableMaxHeight.value,
        modelValue: tableData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tableData.value = $event),
        onShowLoading: showViewLoading
      }, null, 8, ["max-height", "modelValue"]), [[_vShow, currentIconSelect.value == 'table']]), currentIconSelect.value == 'line' ? (_openBlock(), _createBlock(LineChart, {
        key: 0
      })) : _createCommentVNode("", true)])], 4), _createElementVNode("div", _hoisted_11, [_createVNode(NumStatistics, {
        title: getTitle(),
        ref_key: "countStatisticsRef",
        ref: countStatisticsRef
      }, null, 8, ["title"])])])])), [[_directive_loading, viewLoading.value]]);
    };
  }

});